import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=0463f948&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=0463f948&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0463f948",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiSharedDialogsDialogMFullPage: require('/app/components/ui/shared/dialogs/DialogMFullPage.vue').default,UiSharedContactForm: require('/app/components/ui/shared/ContactForm.vue').default})
